<div fxLayout="column" style="padding:15px;">

  <app-page-header *ngIf="pageLoaded" [title]="pageTitle" action=''></app-page-header>

  <div fxLayout="column" fxLayoutAlign="center center center" style="margin-top:50px;" fxLayoutGap="10px">

    <div fxLayout="row" fxLayoutAlign="start" style="overflow-y: auto;" [style.height.px]="tableHeight"
         class="mat-elevation-z0">
      <table mat-table [dataSource]="details" matSort>
        <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center"
                  class="mat-elevation-z0">
          <mat-spinner
            color="primary"
            mode="indeterminate">
          </mat-spinner>
        </mat-card>

        <ng-container matColumnDef="event_description"  >
          <th mat-header-cell *matHeaderCellDef fxFlex="25" fxLayoutAlign="start center center"> Ενέργεια </th>
          <td mat-cell *matCellDef="let log" fxFlex="25" fxLayoutAlign="start center center"> {{log.event_description}} </td>
        </ng-container>

        <ng-container matColumnDef="action_date" >
          <th mat-header-cell *matHeaderCellDef  fxFlex="25" fxLayoutAlign="center center center"> Ημ. Ενέργειας </th>
          <td mat-cell *matCellDef="let log"  fxFlex="25" fxLayoutAlign="center center center"> {{log.action_date}} </td>
        </ng-container>

        <ng-container matColumnDef="parent" >
          <th mat-header-cell *matHeaderCellDef  fxFlex="25" fxLayoutAlign="center center center"> Γονέας </th>
          <td mat-cell *matCellDef="let log"  fxFlex="25" fxLayoutAlign="center center center"> {{log.action_user}} </td>
        </ng-container>

        <ng-container matColumnDef="previous_value">
          <th mat-header-cell *matHeaderCellDef fxFlex="25" fxLayoutAlign="center center center">Προηγούμενη κατάσταση</th>
          <td mat-cell *matCellDef="let log" fxFlex="25" fxLayoutAlign="center center center">
            <div class="statusButton" *ngIf="log.previous_value !== null" [ngStyle]="{'background-color': commonService.getButtonColor(log.previous_value)}"
                 fxLayoutAlign="center center center">{{log.previous_value === 1 ? 'Αποδοχή' : log.previous_value === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef fxFlex="25" fxLayoutAlign="center center center">Αλλαγή κατάστασης σε</th>
          <td mat-cell *matCellDef="let log" fxFlex="25" fxLayoutAlign="center center center">
            <div *ngIf="log.value" class="statusButton" [ngStyle]="{'background-color': commonService.getButtonColor(+log.value)}"
                 fxLayoutAlign="center center center">{{+log.value === 1 ? 'Αποδοχή' : +log.value === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
          </td>
        </ng-container>



        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
        <tr mat-row *matRowDef="let record; columns: columnsToDisplay"></tr>
      </table>
    </div>
  </div>
</div>
